import PPSelect, { PPSelectOptions } from 'components/PPSelect'
import { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { PrivacyStatus } from 'shared'
import { ComposerYoutubePost } from 'shared/types'
import styles from '../BulkPost.pcss'
import { BulkNetworkOptionsProps } from './types'

const YT_PRIVACY_SELECT_OPTIONS: PPSelectOptions = {
  public: { label: <FormattedMessage id="composer.labels.youtube.switch-privacy.public" /> },
  private: { label: <FormattedMessage id="composer.labels.youtube.switch-privacy.private" /> },
  unlisted: { label: <FormattedMessage id="composer.labels.youtube.switch-privacy.unlisted" /> }
}

export function YouTubeBulkOptions(props: BulkNetworkOptionsProps) {
  const { post, recycleSelector } = props
  const data = post.data as ComposerYoutubePost

  const onPrivacyStatusChange = (value: string) => {
    props.onYoutubePrivacyChange(post.id, value as PrivacyStatus)
  }

  return (
    <Fragment>
      <div className={styles.option}>{recycleSelector}</div>
      <PPSelect
        name={<FormattedMessage id="composer.labels.youtube-privacystatus-placeholder" />}
        options={YT_PRIVACY_SELECT_OPTIONS}
        selectedValue={data.privacyStatus}
        withCaret
        className={styles.option}
        id={`youtube-privacy-select-${post.id}`}
        onSelectionChange={onPrivacyStatusChange}
      />
    </Fragment>
  )
}
